module.exports = __webpack_public_path__ + "img/Asset3@8x.596f3de1.png";